import { useState } from 'react';
import CustomTable from './CustomTable';
import {
    Grid,
    Stack,
    Snackbar,
    Alert,
} from '@mui/material';
import {
    interUserUpdateRow,
    externalUserUpdateRow,
} from 'services';

export const ManageUserGrid = ({
    setPaginationModel,
    paginationModel,
    labUserCheck,
    updateExternalManageUser,
    getExternalUserDetails
}: any) => {
    const [successMessage, setSuccessMessage] = useState(false);
    const [manageUserError, setManageUserError] = useState(false);
    const [clientName, setClientName] = useState<any>();
    const [isLockStatus, setIsLockStatus] = useState(false);
    const [error, setError] = useState(false);
    const [open, setOpen] = useState(false);

    let internalUser = (labUserCheck && (labUserCheck?.UserType === 'Internal'));

    const handleSave = (items: any) => {
        const externalClientId = items?.clientId || items?.clientUserMaps?.[0]?.clientID || items?.clientUserMaps?.[0]?.id || '';

        let params = {
            "id": items?.id,
            "firstName": items?.firstName,
            "lastName": items?.lastName,
            "email": items?.email,
            "isLocked": items?.isLocked,
            "isActive": items?.isActive,
            "clientUserMaps": items?.clientUserMaps,
            "areClientsModified": items?.areClientsModified ? true : false,
            ...(!internalUser ? {
                "clientId": externalClientId,
                "isAdmin": !!items?.isAdmin,
                "quotes": !!items?.quotes,
                "bottleOrders": !!items?.bottleOrders,
                "showAllResults": !!items?.showAllResults
            } : {})
        }

        let selectApi: any = internalUser ? interUserUpdateRow : externalUserUpdateRow;

        selectApi(params).then((res: any) => {
            if (res.status === 200) {
                setSuccessMessage(true);
                if (internalUser) {
                    updateExternalManageUser();
                } else{
                    getExternalUserDetails();
                }
                if (isLockStatus) {
                    setManageUserError(true);
                    setClientName(items);
                }
                setIsLockStatus(false);
            } else {
                setError(res?.data);
                setOpen(true);
                setSuccessMessage(false);
            }
        })
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                    <CustomTable
                        setPaginationModel={setPaginationModel}
                        paginationModel={paginationModel}
                        handleSave={handleSave}
                        labUserCheck={labUserCheck}
                        isLockStatus={isLockStatus}
                    />
                </Grid>
            </Grid>
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={successMessage} autoHideDuration={6000} onClose={() => setSuccessMessage(false)}>
                    <Alert severity="success" onClose={() => setSuccessMessage(false)}>Successfully Updated!</Alert>
                </Snackbar>
                <Snackbar open={manageUserError} autoHideDuration={6000} onClose={() => setManageUserError(false)}>
                    <Alert severity="success"
                        onClose={() => setManageUserError(false)}>
                        One Time Password sent to {clientName?.firstName} {clientName?.lastName} for password reset.
                    </Alert>
                </Snackbar>
                <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
                    <Alert severity="warning" onClose={() => setOpen(false)}>{error}</Alert>
                </Snackbar>
            </Stack>
        </div >
    );
}
